import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Groupbuying = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        fillRule: "nonzero",
        d: "M9 8.242a1.54 1.54 0 0 1-1.537-1.537c0-.848.69-1.537 1.537-1.537.848 0 1.537.69 1.537 1.537A1.54 1.54 0 0 1 9 8.242m3.953-1.17a1.54 1.54 0 0 0 1.537-1.537 1.54 1.54 0 0 0-1.537-1.538 1.54 1.54 0 0 0-1.538 1.538c0 .848.69 1.537 1.538 1.537m0 .428c-.908 0-1.733.412-2.348 1.088 1.432.735 2.265 2.34 2.34 3.937 0 .127 0 .255-.015.375h2.258q.53 0 .892-.45.36-.452.338-1.072c-.09-2.146-1.613-3.87-3.465-3.87zm-7.905 0c-1.845 0-3.368 1.725-3.458 3.87q-.023.621.337 1.073c.24.3.548.45.893.45h2.257a2 2 0 0 1-.014-.376c.067-1.59.9-3.194 2.34-3.937-.615-.675-1.448-1.088-2.348-1.088zm0-.428a1.54 1.54 0 0 0 1.537-1.537 1.54 1.54 0 0 0-1.537-1.538A1.54 1.54 0 0 0 3.51 5.535c0 .848.69 1.537 1.538 1.537M9 8.678c-1.845 0-3.367 1.724-3.457 3.87q-.023.62.337 1.072c.24.3.548.45.893.45h4.454q.531 0 .893-.45.36-.452.338-1.072c-.09-2.146-1.613-3.87-3.458-3.87"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h18v18H0z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Groupbuying$1 = Svg18Groupbuying;

export { Svg18Groupbuying$1 as default };
